import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ReviewHeader = ({
  review,
  closedReviews,
  totalReviews,
  category,
  headerImage,
}) => (
  <Fragment>
    <div className="review-header">
      <img src={`${headerImage}`} alt="" />
      <div className="dark-overlay" />
      <div className="container">
        <div className="pretitle">{category}</div>
        <div className="title">{review.name}</div>
        <div className="subtitle">{review.date}</div>
        <div className="description">{closedReviews} de {totalReviews} revisiones consumidas</div>
      </div>
    </div>
  </Fragment>
);

ReviewHeader.propTypes = {
  review: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    date: PropTypes.string,
    status: PropTypes.string,
    isFinal: PropTypes.bool,
  }).isRequired,
  closedReviews: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
  headerImage: PropTypes.string.isRequired,
};

export default ReviewHeader;

